import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { UniversityPerson } from '@uiowa/university-person';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'university-person',
    templateUrl: './university-person.component.html',
    styleUrls: ['./university-person.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UniversityPersonComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => UniversityPersonComponent), multi: true }
    ]
})
export class UniversityPersonComponent implements OnInit, ControlValueAccessor {

    @Input() canDelete = false;
    @Input() canEdit = true;
    @Input() isInvalid = false;
    @Output() onChangePerson: EventEmitter<any> = new EventEmitter<any>();
    @Output() onDeletePerson: EventEmitter<any> = new EventEmitter<any>();

    universityPersonForm: FormGroup;
    get universityPerson(): AbstractControl {
        return this.universityPersonForm.get('universityPerson');
    }

    constructor(
        private readonly fb: FormBuilder,
        private readonly toastrService: ToastrService
    ) {
        this.universityPersonForm = this.fb.group({
            universityPerson: ['']
        });
    }

    ngOnInit() {
        this.universityPerson.valueChanges.subscribe((value) => {
            this.propagateChange(value);
        });
    }

    changePerson() {
        this.universityPerson.setValue(null);
        this.universityPerson.updateValueAndValidity();
        this.onChangePerson.emit();
    }

    deletePerson() {
        this.onDeletePerson.emit();
    }

    noPeopleFound() {
        this.toastrService.error(`No person found. `, null,
            {
                timeOut: 8000,
                onActivateTick: true
            });
    }

    propagateChange = (_: any) => { };
    validateFn: any = () => { };

    writeValue(universityPerson: UniversityPerson): void {
        this.universityPerson.setValue(universityPerson);
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }

    validate(c: FormControl) {
        return this.validateFn(c);
    }
}
